import wizard from './init-wizard/triggers';
import auth from './modules/authentication/triggers';
import routing from './modules/routing/triggers';
import dashboard from './modules/dashboard/triggers';
import user from './modules/users/triggers';
import * as inventory from './modules/inventory/triggers';
import * as addressBook from './modules/address-book/triggers';
import * as dailyRental from './modules/daily-rental/triggers';
import * as content from './modules/content/triggers';
import * as email from './modules/email/triggers';
import * as settings from './modules/settings/triggers';

export default { wizard, auth, routing, dashboard, user, ...inventory, ...addressBook, ...dailyRental, ...content, ...email, ...settings };



// WEBPACK FOOTER //
// ./src/frontend/triggers.js